import { flexStyles } from "../flexStyles/flexStyles";
import { fontFamily, fontSize, fontWeight } from "../miFontstyles";
import { palette } from "../miPalette/miPalette";
import {
  shadows as boxShadows,
  breakpoint,
  zIndex,
} from "../miStandard/miStandard";
import { styles } from "../miStyles";
import { textColor, typography } from "../miTypography";

export const MiTHEME = {
  colors: palette,
  palette,
  zIndex,
  breakpoint,
  fontSize,
  fontWeight,
  fontFamily,
  typography,
  textColor,
  styles,
  boxShadows,
  flexStyles,
  components: {
    MuiFormLabel: {
      styleOverrides: {
        asterisk: { color: palette.red.main },
      },
    },
    // colors for MuiChip
    MuiChip: {
      styleOverrides: {
        colorSuccess: {
          backgroundColor: palette.green.main,
        },
        colorError: {
          backgroundColor: palette.red.dark,
        },
        colorWarning: {
          backgroundColor: palette.orange.main,
        },
        colorInfo: {
          backgroundColor: palette.blue.main,
        },
        colorSecondary: {
          backgroundColor: palette.grey.main,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          variants: [
            {
              props: { type: "number" },
              style: {
                "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                  {
                    WebkitAppearance: "inner-spin-button",
                    opacity: 1,
                    margin: 0,
                  },
                "& input[type=number]": {
                  MozAppearance: "auto",
                },
              },
            },
            {
              props: { readOnly: true },
              style: {
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    border: "none",
                  },
                  "& .MuiInputBase-input.Mui-disabled": {
                    WebkitTextFillColor: palette.common.black,
                  },
                },
                "& .MuiInputLabel-root": {
                  fontWeight: fontWeight.regular,
                },
                "& .MuiInputLabel-root.Mui-disabled": {
                  color: palette.common.black,
                },
                "& .MuiSelect-icon": {
                  display: "none",
                },
              },
            },
          ],
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          variants: [
            {
              props: { readOnly: true },
              style: {
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    border: "none",
                  },
                  "& .MuiInputBase-input.Mui-disabled": {
                    WebkitTextFillColor: palette.common.black,
                  },
                },
                "& .MuiInputLabel-root": {
                  color: palette.common.black,
                },
                "& .MuiInputLabel-root.Mui-disabled": {
                  color: palette.common.black,
                },
                "& .MuiAutocomplete-endAdornment": {
                  display: "none",
                },
              },
            },
          ],
        },
      },
    },
  },
};
